import { useState } from "react";

type Score = {
  c: number;
  vc: number;
  dp: number;
  auto: number;
  lh: number;
  nlh: number;
};

const VCCalculator = () => {
  const [score, setScore] = useState<Score>({
    c: 0,
    vc: 0,
    dp: 0,
    auto: 0,
    lh: 0,
    nlh: 0,
  });
  const handleChange = (key: string, value: string) => {
    const newScore = calculateScore({
      ...score,
      [key]: parseInt(value),
    });
    setScore(newScore);
  };

  const calculateScore = (score: Score) => {
    const nlh = score["vc"] + score["c"] * 2 + score["dp"];
    const lh = score["vc"] * 2 + score["c"] + score["auto"];
    return {
      ...score,
      lh,
      nlh,
    };
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 md:grid-cols-2 md:grid-rows-2 gap-2">
        <label className="leading-7 flex flex-col gap-2 text-sm text-gray-600">
          Vice Captain&apos;s Score
          <input
            type="number"
            className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            name="ViceCaptainsScore"
            onChange={(e) => handleChange("vc", e.target.value)}
          ></input>
        </label>
        <label className="leading-7 flex flex-col gap-2 text-sm text-gray-600">
          Captain&apos;s Score
          <input
            type="number"
            className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            name="CaptainsScore"
            onChange={(e) => handleChange("c", e.target.value)}
          ></input>
        </label>
        <label className="leading-7 flex flex-col gap-2 text-sm text-gray-600">
          Dropped Player&apos;s Score
          <input
            type="number"
            className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            name="DroppedPlayerScore"
            onChange={(e) => handleChange("dp", e.target.value)}
          ></input>
        </label>
        <label className="leading-7 flex flex-col gap-2 text-sm text-gray-600">
          Auto Emergency Score
          <input
            type="number"
            className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            name="autoemergencyscore"
            onChange={(e) => handleChange("auto", e.target.value)}
          ></input>
        </label>
      </div>
      <div className="grid grid-cols-1 grid-rows-2 md:grid-rows-1 md:grid-cols-2 gap-2">
        <div className="flex flex-col">
          <p className="text-lg">Loophole Score</p>
          <p>Score if the loophole is used</p>
          <p className="text-xl font-bold">{score.lh}</p>
        </div>
        <div className="flex flex-col">
          <p className="text-lg">Non Loophole Score</p>
          <p>Score if the loophole is not used</p>
          <p className="text-xl font-bold">{score.nlh}</p>
        </div>
      </div>
    </div>
  );
};

export default VCCalculator;
